export default {
      id: "sort-inactive-usage",
      viewBox: "0 0 7 10",
      url: __webpack_public_path__ + "app/svg/sprite.svg#sort-inactive",
      toString: function () {
        return this.url;
      }
    }